import { Directive, inject, input, TemplateRef } from '@angular/core';

export interface TableCellContext {
  $implicit: unknown;
}

@Directive({
  selector: '[ocpTableCell]',
})
export class TableCellDirective {
  readonly ocpTableCell = input.required<string>();
  readonly templateRef = inject(TemplateRef<TableCellContext>);
}
